import { render, staticRenderFns } from "./PersonalQuestionaire.vue?vue&type=template&id=4c551ae0"
import script from "./PersonalQuestionaire.vue?vue&type=script&lang=js"
export * from "./PersonalQuestionaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports